import { BookingStates } from '../../../../../constants/booking-states';

export const shouldShowAddress = (booking, isGuestView) => {
  const shouldShow =
    isGuestView &&
    booking?.obj_state &&
    ![
      BookingStates.OFFER_SUBMITTED,
      BookingStates.OFFER_WITHDRAWN,
      BookingStates.OFFER_DECLINED,
      BookingStates.OFFER_EXPIRED,
      BookingStates.CANCELLED,
      BookingStates.HOST_UPDATE_REQUESTED
    ].includes(booking.obj_state);

  return shouldShow;
};
